import React, { createContext, useCallback, useContext, useMemo } from 'react'

import history from '@/routes/history'

import {
  AUTH_LOGIN_PATH,
  AUTH_SIGNUP_PATH,
  buildAuthPageSearch,
} from '../utils/auth-return'

const AuthPageNavigationContext = createContext(null)

export function AuthPageNavigationProvider ({ children, onShowForgotPassword, onHideForgotPassword }) {
  const goToLogin = useCallback(() => {
    onHideForgotPassword?.()
    history.push({
      pathname: AUTH_LOGIN_PATH,
      search: buildAuthPageSearch(window.location.search),
    })
  }, [onHideForgotPassword])

  const goToSignup = useCallback(() => {
    history.push({
      pathname: AUTH_SIGNUP_PATH,
      search: buildAuthPageSearch(window.location.search),
    })
  }, [])

  const goToForgotPassword = useCallback(() => {
    onShowForgotPassword?.()
  }, [onShowForgotPassword])

  const value = useMemo(() => ({
    isAuthPage: true,
    goToLogin,
    goToSignup,
    goToForgotPassword,
  }), [goToForgotPassword, goToLogin, goToSignup])

  return (
    <AuthPageNavigationContext.Provider value={value}>
      {children}
    </AuthPageNavigationContext.Provider>
  )
}

export function useAuthPageNavigation () {
  return useContext(AuthPageNavigationContext)
}
